import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';

@jsonObject
export class PublicCartAddItemRequest {
  @jsonMember(String)
  public readonly productId!: Guid;

  @jsonMember(Number)
  public readonly quantity!: number;

  @jsonMember(String)
  public readonly subProductId!: Nillable<Guid>;

  public constructor(
    private readonly data: {
      productId: Guid;
      quantity: number;
      subProductId?: Nillable<Guid>;
    },
  ) {
    this.productId = this.data.productId;
    this.quantity = this.data.quantity;
    this.subProductId = this.data.subProductId;
  }
}
